'use strict';
/**
 * Some useful packages (you can install by using npm)
 * 1. webfontloader  = async font loaders
 * 2. slick-carousel = Simple, easy, responsive carousel (buggy centerMode - variableWidth - lazyMode)
 * 3. jquery-match-height = Use this to match the height of elements. Either use this or Equalizer from Foundation
 * 4. dropkickjs = if you need custom dropdown
 *
 * IMPORTANT:
 * To import async-ly, you need to wrap your codes in require.ensure([], () => { });
 * It's best not to async plugins, to leverage browser cache
 * Ref: https://webpack.github.io/docs/code-splitting.html
 *
 * NOTES:
 * This boilerplate uses CDN/external for jQuery package. Configured in gulp/webpack.js.
 * This to prevent the needs of jQuery from node_modules
 */

///////////////
// Libraries //
///////////////
// import wf from 'webfontloader';
import ssm from 'simplestatemanager';
import mh from 'jquery-match-height';
import jsCookie from 'js-cookie';
import JSON5 from 'json5';

////////////////////////
// Components / Utils //
////////////////////////
import ScrollTo from './partials/ScrollTo';
import HeaderUtil from './partials/HeaderUtil';

//////////////////
// Bootstrap JS //
//////////////////
// Tab
require('bootstrap-sass/assets/javascripts/bootstrap/tab');
// Collapse
require('bootstrap-sass/assets/javascripts/bootstrap/collapse');
// Dropdown
require('bootstrap-sass/assets/javascripts/bootstrap/dropdown');
// Transition
require('bootstrap-sass/assets/javascripts/bootstrap/transition');


/////////////
// Plugins //
/////////////

// wf.load({
//     google: {
//       families: ['Open Sans:400,600,800:latin', 'Slabo 27px:400:latin']
//     }
// });

// Setting Webpack public path dynamically so that it loads the partials
// from the folder where the main.js is located
var bundleSrc = $('[src*="/main.js"]').attr("src");
__webpack_public_path__ = bundleSrc.substr(0, bundleSrc.lastIndexOf("/") + 1);

$(() => {
	const IsIE10Below = $('.lt-ie10').length;

	//////////////////
	// Match Height //
	//////////////////

	/**
	 * data-mh-group is different from data-mh data-mh can be used natively straight from matchHeight
	 * data-mh-group (require data-mh-options if needed) should be used like data-mh-group='groupName' that will be used as a selector
	 * data-mh-options will be used for the options of the match height
	 */

	let $jsMh = $('[data-mh-group]');
	if ($jsMh.length) {
		let groupArray = [];
		$jsMh.each(function(i, el) {
			let $el = $(el);
			let mhOptions = $el.attr('data-mh-options');
			let mhGroup = $el.attr('data-mh-group');
			let jsMhOptions = {};
			if (mhGroup) {
				if (mhOptions) {
					jsMhOptions = JSON5.parse(mhOptions);
				}

				if (!(groupArray.filter(item => item.group == mhGroup)).length) {
					groupArray.push({ group: mhGroup, options: jsMhOptions });
				}
			}
		});

		groupArray.forEach(function(obj) {
			let proceed = 1;

			// if nonFlexBrowserOnly is enabled, check whether the browser is > ie9 or not
			// if it's <= ie9, proceed = 1
			// else proceed 0
			if(obj.options.nonFlexBrowserOnly && $('.lt-ie10').length == 0){
				proceed = 0;
			}

			if(proceed){
				$(`[data-mh-group="${obj.group}"]`).matchHeight(obj.options);
			}
		});
	}

	//////////////////
	// Font Resizer //
	//////////////////
	let $jsFontResizer = $('[data-fontresizer]');
	if($jsFontResizer.length){

		$jsFontResizer.on('click', function(){
			let $this = $(this);
			let $target = $('html');
			let isIncrease  = ($this.attr('data-fontresizer')).toLowerCase() == 'l';
			let newFontSize = parseFloat($target.css('font-size'), 10) * (isIncrease ? 1.2 : (1/1.2));
			$target.css('font-size', newFontSize);
			// save it to cookie
			jsCookie.set('fontsizecookie', newFontSize);

			$('[data-slickjs]').slick('setPosition');
		});
	}

	///////////////
	// Triggerer //
	///////////////
	let $jsTriggerer = $('[data-triggerer]');
	if($jsTriggerer.length){
		$jsTriggerer.each(function(){
			let $this = $(this);
			let attr = $this.attr('data-triggerer');
			if(attr){
				// opts
				// opt.target = target (CSS string selector)
				// opt.sourceEvents = (str) default(click) - the events that trigger eventTriggers
				// opt.triggerEvents = (str) the events triggered on the target
				let opt = JSON5.parse(attr);

				// if on enter
				let isOnEnter = opt.sourceEvents == 'enter';

				if(isOnEnter){
					opt.sourceEvents = 'keypress';
				}

				$this.on(opt.sourceEvents, function(e){
					if(isOnEnter){
						if(e.which == 13){
							if($this.val() != ''){
								$(opt.target).trigger(opt.triggerEvents);
							}
						}
					} else{
						$(opt.target).trigger(opt.triggerEvents);
					}
				});
			}
		});
	}

	///////////////////
	// Slick Sliders //
	///////////////////
	let $jsSlick = $('[data-slickjs]');
	if ($jsSlick.length) {
		require.ensure([], () => {
			require('slick-carousel');

			const accessiblePagingFn = function(slider, i) {
				return $('<button type="button" data-role="none" role="button" tabindex="0" aria-label="slide ' + (i + 1) + '" />');
			};

			const jsSlickOptions = {
				'homeslider': {
					dots: true,
					infinite: true,
					slidesToShow: 2,
					slidesToScroll: 2,
					prevArrow: '.c-homeslider__arrow--prev',
					nextArrow: '.c-homeslider__arrow--next',
					responsive: [{
						breakpoint: 992,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							appendDots: '.c-homeslider__dots'
						}
					}],
					onInit: function($slick, opt){
						$slick.find('[data-anime-count]').each(function(){
							const animedata = $(this).data('anime');
							if(animedata) animedata.play();
						});
					},
					customPaging: accessiblePagingFn
				},
				'headerslider': {
					autoplay: true,
					dots: true,
					infinite: true,
					prevArrow: '.c-headerslider__arrow--prev',
					nextArrow: '.c-headerslider__arrow--next',
					appendDots: '.c-headerslider__dots',
					adaptiveHeight: true,
					onInit: function($slick, opt){
						
						$('.c-headerslider .c-headerslider__dots').prepend('<div class="slick-pause play"></div>'); 
						$('.slick-pause').bind("click", function(e) {
						  e.preventDefault();
				          if ($(this).attr("class") == "slick-pause play"){
				            	$(this).attr("class", "slick-pause pause");
				         		$('[data-slickjs="headerslider"]').slick('slickPause');
				          }else{
				            	$(this).attr("class", "slick-pause play");
				         		$('[data-slickjs="headerslider"]').slick('slickPlay');
				         	}
				        });


					},
					customPaging: accessiblePagingFn
					
				},
				'contentslider': {
					dots: true,
					infinite: true,
					customPaging: accessiblePagingFn
				}
			};

			$jsSlick.each(function() {
				let $el = $(this);
				let key = $el.data('slickjs');
				$el
					.on('init', function(){
						if(jsSlickOptions[key] && (jsSlickOptions[key]).onInit){
							(jsSlickOptions[key]).onInit($(this), jsSlickOptions[key]);
						}
					})
					.slick(jsSlickOptions[key] || {});
			});
		}, 'sliders');
	}

	/////////////
	// FocusOn //
	/////////////
	let $focusOn = $('[data-focuson]');
	if ($focusOn.length) {
		require.ensure([], () => {
			const FocusOn = require('./partials/FocusOn');
			new FocusOn($focusOn);
		}, 'focuson');
	}

	////////////////////////
	// Counting Animation //
	////////////////////////

	/**
	 * Usage: [data-anime-count="targetNumber"]
	 * targetNumber is the end value that will be animated
	 */

	let $jsCount = $('[data-anime-count], .js-animecount');
	if($jsCount.length && !IsIE10Below){
		require.ensure([], function(){
			const animecount = require('./partials/animecount');
			animecount($jsCount);
		}, 'animecount');
	}

	//////////////////
	// Init Toggler //
	//////////////////
	let $jsVtoggle = $('[data-vtoggle]');
	$jsVtoggle.each(function(){
		let $this = $(this);
		let { selfClass, class:cls, target, event:ev, hasTransition, transitionProperty, removeClass } = JSON5.parse($this.attr('data-vtoggle'));

		$this.on(ev || 'click', function() {
			let $this = $(this);

			if(cls){
				let $target = $(target)
					.toggleClass(cls)
					.addClass(`${cls}-is-loading`);

					if(removeClass){
						$target.removeClass(removeClass);
					}

					if(hasTransition){
						$target.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(e){
							if(transitionProperty == e.originalEvent.propertyName){
								let $this = $(this);
								$this.removeClass(`${cls}-is-loading`);
							}
						});
					}
			}

			if(selfClass){
				$this.toggleClass(selfClass);
			}
		});
	});

	////////////////
	// Scroll To //
	////////////////
	let $scrollTo = $('[data-scrollto]');
	if ($scrollTo.length) {
		new ScrollTo($scrollTo);
	}

	////////////
	// Sticky //
	////////////
	let $stickies = $('[data-sticky]');
	const stickyPromise = new Promise( resolve => {
		if($stickies.length){
			require.ensure([], function(){
				const Sticky = require('./partials/Sticky');
				$stickies.each(function(){
					let $this = $(this);
					$this.data('sticky-object', new Sticky($this));
				});
				resolve();
			}, 'sticky');
		}
	});
	const setStickyWidthBasedOnScreen = (isReset) => {
		stickyPromise.then(function(){
			console.info('sticky resolve');
			$stickies.each(function(){
				let $this = $(this);
				let obj = $this.data('sticky-object');
				obj.setWidth(isReset);
			});
		});
	};

	///////////////
	// ScrollSpy //
	///////////////
	let $scrollSpies = $('[data-scrollspy]');
	const scrollSpyPromise = new Promise ( resolve => {
		if($scrollSpies.length){
			require.ensure([], function(){
				const ScrollSpy = require('./partials/ScrollSpy');
				$scrollSpies.each(function(){
					let $this = new ScrollSpy($(this));
				});
				resolve();
			}, 'scrollspy');
		}
	});

	//////////////////////
	// Bootstrap Select //
	//////////////////////
	const $jsSelect = $('.js-select');
	let bsSelectPromise = new Promise(resolve => {
		if ($jsSelect.length) {
			require.ensure([], () => {
				require('bootstrap-select');

				let initSelect = ($el) => {
					$el
					.off('rendered.bs.select').on('rendered.bs.select', function(e){
						$(this).addClass('is-rendered');
					})
					.selectpicker({
						dropupAuto: false,
						mobile: true
					});
				};

				initSelect($jsSelect);
				resolve(initSelect);

			}, 'bootstrap-select');
		} else {
			resolve();
		}
	});

	///////////////////
	// Images Loaded //
	///////////////////
	const $imagesLoaded = $('[data-imagesloaded]');
	if($imagesLoaded.length){
		require.ensure([], function(){
			require('imagesloaded');

			const options = {
				"home": {
					background: true,
					callback: function(obj){
						$(obj.elements).each(function(){
							$(this).addClass('is-images-loaded');
						});
					}
				}
			};

			$imagesLoaded.each(function(){
				let $this = $(this);
				let key = $(this).attr('data-imagesloaded');
				$this.imagesLoaded(options[key] || {}, options[key] ? (options[key]).callback : null);
			});
		}, 'imagesloaded');
	}

	//////////////
	// Fit Text //
	//////////////
	const $fitTexts = $('[data-fittext]');
	if($fitTexts.length){
		require.ensure([], function(){
			require('./partials/jquery.fittext');
			// options
			// compressor: (default 1)
			// min: minFontSize (int or string(px)) (default Number.NEGATIVE_INFINITY,)
			// max: maxFontSize (int or string(px)) (default Number.POSITIVE_INFINITY)

			$fitTexts.each(function(){
				const $this = $(this);
				const attr = $this.attr('data-fittext');
				let opts = {};
				opts.compressor = opts.compressor || 1;
				opts.min = opts.min || Number.NEGATIVE_INFINITY;
				opts.max = opts.max || Number.POSITIVE_INFINITY;
				if(attr){
					opts = JSON5.parse(attr);
				}
				$this.fitText(opts.compressor, { minFontSize: opts.min, maxFontSize: opts.max });
			});
		}, 'fittext');
	}

	//////////
	// Misc //
	//////////
	HeaderUtil.initClearSearch();
	HeaderUtil.initSearchButtonClick();

	////////////////////////////////////////////////
	// Save / load font size changes from cookies //
	////////////////////////////////////////////////
	let fontsizecookie = jsCookie.get('fontsizecookie');
	if(fontsizecookie){
		$('html').css('font-size', parseFloat(fontsizecookie));
	}

	///////////////////////////////////////////////////////////////
	// Disable glossary links that have no reference on the page //
	///////////////////////////////////////////////////////////////
	$('.o-sideglossaryindex__col').each(function(){
		let $this = $(this);
		let $link = $this.find('[href^="#glossary-"]');
		let alphabetTargetId = $link.attr('href');

		if(!$(alphabetTargetId).length){
			$link.addClass('o-sideglossaryindex__anchor is-disabled');
		}
	});

	/////////
	// SSM //
	/////////
	ssm.addStates([{
		id: 'xs',
		query: '(max-width: 767px)',
		onEnter: () => {
			console.info('enter <=767px');
			HeaderUtil.initCloseOffCanvas();
		},
		onLeave: () => {
		},
	}, {
		id: 'sm',
		query: '(max-width: 991px)',
		onEnter: () => {
			console.info('enter <=991px');
			setStickyWidthBasedOnScreen(true);
			HeaderUtil.initCloseOffCanvas();
		},
		onLeave: () => {
			console.info('leave <=991px');
		}
	}, {
		id: 'md',
		query: '(max-width: 1199px)',
		onEnter: () => {
			console.info('enter <=1199px');
			setStickyWidthBasedOnScreen();
		},
		onLeave: () => {
			console.info('leave <= 1199px');
			setStickyWidthBasedOnScreen();
		}
	}, {
		id: 'desktop',
		query: '(min-width: 992px)',
		onEnter: () => {
			console.info('enter >= 992px');
			HeaderUtil.initMegamenu();
			setStickyWidthBasedOnScreen();
		},
		onLeave: () => {
		}
	} ]);
});



// WEBPACK FOOTER //
// ./src/_js/main.js